import ReactGA from "react-ga4";

export const initAnalytics = () => {
  try {
    ReactGA.initialize("G-HRVGGJ1TE2");
  } catch (error) {
    console.warn("Analytics initialization failed:", error);
  }
};

export const trackPageView = (path: string) => {
  try {
    ReactGA.send({ hitType: "pageview", page: path });
  } catch (error) {
    console.warn("Analytics pageview tracking failed:", error);
  }
};
